import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {useNavigate} from 'react-router-dom';
import {BottomSheet} from 'react-spring-bottom-sheet';

function AddStoryBS({open, setIsOpen}: {open: boolean; setIsOpen: () => void}) {
  const navigate = useNavigate();
  return (
    <BottomSheet
      onDismiss={setIsOpen}
      open={open}
      blocking={true}
      className="custom-bottom-sheet"
    >
      <div className="flex flex-col gap-4 p-6 text-sm text-gray-900">
        <div className="flex items-center justify-end text-md font-medium">
          <SpanIcon
            className="icon-nameClose-remove text-2xl"
            onClick={setIsOpen}
          />
        </div>
        <p className="text-md font-medium">
          برای ثبت استوری فروشگاه خود را ارتقا دهید.
        </p>
        <div className="flex items-center gap-4">
          <button
            onClick={setIsOpen}
            className="border-[1px] border-solid border-red-600 text-red-600 flex-1 py-2.5 px-3 rounded-lg"
          >
            انصراف
          </button>
          <button
            className="bg-farm-shop-500 text-white flex-1 py-2.5 px-3 rounded-lg"
            onClick={() => navigate('/account/promotion/store')}
          >
            ارتقا فروشگاه
          </button>
        </div>
      </div>
    </BottomSheet>
  );
}

export default AddStoryBS;
